/** @format */

import {useState} from 'react';

export const useTableSort = (
    data = [],
    initialSortColumn = 'invoiceId',
    initialSortOrder = 'asc'
) => {
    const [sortColumn, setSortColumn] = useState(initialSortColumn);
    const [sortOrder, setSortOrder] = useState(initialSortOrder);

    const sortedData = data.sort((a, b) => {
        let aValue, bValue;

        switch (sortColumn) {
            case 'invoiceId':
                aValue = a.id;
                bValue = b.id;
                break;
            case 'amount':
                aValue = a.total - a.partial_payments;
                bValue = b.total - b.partial_payments;
                break;
            case 'date':
                aValue = new Date(a.shipped_time);
                aValue.setDate(aValue.getDate() + 30); // add 30 days
                bValue = new Date(b.shipped_time);
                bValue.setDate(bValue.getDate() + 30); // add 30 days
                break;
            default:
                return 0;
        }

        return sortOrder === 'asc' ? aValue - bValue : bValue - aValue;
    });

    const toggleSort = column => {
        const order = sortColumn === column && sortOrder === 'asc' ? 'desc' : 'asc';
        setSortColumn(column);
        setSortOrder(order);
    };

    return {sortedData, sortColumn, sortOrder, toggleSort};
};
